<template>
  <Page>
    <component v-bind:is="component" />
  </Page>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import './Confirmacao.css'
import ImeiCadastro from '../ImeiCadastro/ImeiCadastro'
import ImeiSucesso from '../ImeiSucesso/ImeiSucesso'
import SerialNumberRegistration from '../SerialNumberRegistration'
import SerialNumberSuccess from '../SerialNumberSuccess'

import Page from '@/components/base/Page'
import InstantPaymentsIndex from './_components/SuccessPages/InstantPayment/index'
import NonInstantPaymentsIndex from './_components/SuccessPages/NonInstantPayment/index'

export default {
	name: 'Confirmacao',
  components: {
    ImeiCadastro,
    SerialNumberRegistration,
    ImeiSucesso,
    SerialNumberSuccess,
    Page,
    NonInstantPaymentsIndex,
    InstantPaymentsIndex
  },
	data () {
		return {
			modalImei: false,
			IMEI: '',
			confirmDeviceIdentification: false,
      serialNumber: '',
      invoiceFileName: '',
      montado: false
		}
	},
  computed: {
    ...mapState(['device']),
    component () {
      const isInstantUndefined = typeof this.device.payment.isInstant === 'undefined'
      return isInstantUndefined || this.device.payment.isInstant ? 'InstantPaymentsIndex' : 'NonInstantPaymentsIndex'
    },
    svgIcon () {
      return this.device.deviceTypeName
        ? require(`@/assets/svg/icon-${this.device.deviceTypeName}-gray-with-shield.svg`)
        : null
    },
    lblIdentification () {
      return this.device.deviceTypeName === 'celular' ? 'IMEI' : 'número de série'
    }
  },
	mounted () {
    this.disparaSucessPayment(this.device.payment.typePayment)

		axios
			.get(`${process.env.VUE_APP_API_URL}/internal-cell-phones/v1/policy/${this.device.payment.planUuid}`, JSON.parse(sessionStorage.config))
      .then((response) => {
        this.serialNumber = response.data.serialNumber
        this.invoiceFileName = response.data.invoiceFileName

        if (!this.serialNumber) {
					this.confirmDeviceIdentification = false
				} else {
					this.confirmDeviceIdentification = true
        }

        this.montado = true
      })
      .catch(error => {
        this.$sentry.logWithContext({
          ctx: { step: '[step/confirmation]' }, error
        })
      })
  },
	methods: {
    handleIMEI (event) {
      this.confirmDeviceIdentification = event
      this.disparaDataLayer()
    },
    disparaImei () {
      window.dataLayer.push({
        event: 'afiliattionTag',
        level: 'checkoutPage',
        rotulo: 'preencher-imei'
      })
    },
    disparaSucessPayment (typePayment) {
			window.dataLayer.push({
        event: 'afiliattionTag',
        level: 'checkoutPage'
      })
		},
		disparaDataLayer () {
			if (this.confirmDeviceIdentification) {
				window.dataLayer.push({
          event: 'afiliattionTag',
          level: 'checkoutPage'
				})
			}
    },
    tracking () {
      window.dataLayer.push({
        event: 'dispositivos-ciclic',
        categoria: 'cadastro-dispositivo',
        acao: this.device.deviceTypeName === 'celular' ? 'IMEI' : 'numero-serie',
        rotulo: '1-continuar'
      })
    }
	}
}
</script>

<style scoped>
.modal-content {
  background-color: white;
}
</style>
